import {GridColDef} from "@mui/x-data-grid";

export const getCommonColumnProperties = (width: number): Partial<GridColDef> => {
    return {width, sortable: true, filterable: true};
};
